import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from '@/views/HomePage';
import DataPortalPage from '@/views/DataPortalPage';

Vue.use(VueRouter);

const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      {
        path: '/dataportal',
        name: 'DataPortal',
        component: DataPortalPage
    },
      {
            path: '/',
            name: 'HomePage',
            component: HomePage
        }
    ],
    scrollBehavior() {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve({ x: 0, y: -20 })
          }, 100)
        })
      }
});

router.afterEach((to) => {
  sendAnalyticsPageview(to);
});

const GA_MEASUREMENT_ID = 'G-SZR8Z5GP8E';

function sendAnalyticsPageview(to) {
  // implemented following Google documentation
  // https://developers.google.com/analytics/devguides/collection/gtagjs/pages
  const pageInfo = {
      page_path: to.path,
      page_title: to.name
  }
  gtag('config', GA_MEASUREMENT_ID, pageInfo);

  
}

export default router;